import ResidentStatusFlagsTemplate from "app/features/residents/templates/ResidentStatusFlagsTemplate";

export default function ResidentStatusFlagsScreen() {
  return <ResidentStatusFlagsTemplate />;
}
